import React from "react";

export default function StartStep({animating, handleStartHelp, handleSkipHelp, handleSendMessage}) {

    return (
        <div className={"container mx-auto px-4 lg:px-8"}>
            <div className={"grid grid-cols-1 lg:grid-cols-12 gap-x-8 gap-y-6"}>

                <div className={"lg:col-span-12"}>
                    <h1 className="text-[35px] leading-[42px] lg:big-text text-center pb-6">
                        Reserve A Dumpster
                    </h1>
                </div>

                <div className={"lg:col-span-4 border-2 border-white rounded-sm bg-brand-green-light px-6 py-8 lg:p-12 flex flex-col justify-between"}>
                    <div>
                        <div className={"heading-h5 text-center"}>
                            Need help choosing the right size?
                        </div>
                        <div className={"text-center mb-4"}>
                            Let’s find it together!
                        </div>
                    </div>
                    <button className={"btn w-full"} disabled={animating} onClick={handleStartHelp}>
                        Find Size
                    </button>
                </div>
                <div className={"lg:col-span-4 border-2 border-white rounded-sm bg-brand-green-light px-6 py-8 lg:p-12 flex flex-col justify-between"}>
                    <div>
                        <div className={"heading-h5 text-center"}>
                            Know what you need?
                        </div>
                        <div className={"text-center mb-4"}>
                            Contractors and homeowners, book your dumpster now!
                        </div>
                    </div>
                    <button className={"btn bg-brand-dark border-brand-dark w-full"} disabled={animating} onClick={handleSkipHelp}>
                        Book Now
                    </button>
                </div>
                <div className={"lg:col-span-4 border-2 border-white rounded-sm bg-brand-green-light px-6 py-8 lg:p-12 flex flex-col justify-between"}>
                    <div>
                        <div className={"heading-h5 text-center"}>
                            Need a quote? Have questions?
                        </div>
                        <div className={"text-center mb-4"}>
                            Reach out to one of our dumpster consultants now!
                        </div>
                    </div>
                    <button className={"btn w-full btn-transparent"} disabled={animating} onClick={handleSendMessage}>
                        Get In Touch
                    </button>
                </div>
            </div>
        </div>
    )
}
